export interface DLFRProps {
  nombreApellido?: string;
  equipos?: Array<number | string>;
  activo?: boolean;
}

export const getDriversFilter = (data: DLFRProps) => {
  const equiposRaw = data?.equipos ?? [];
  const equipos = (equiposRaw ?? [])
    .map((x) => (typeof x === "number" ? x : Number(x)))
    .filter((x) => Number.isFinite(x));

  return {
    ...(data?.nombreApellido
      ? {
          nombreApellido: data?.nombreApellido,
        }
      : {}),
    ...(typeof data?.activo === "boolean" ? { activo: data?.activo } : {}),
    ...(equipos.length ? { equipos } : {}),
  };
};
